import React, { useState, useLayoutEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import { CloseCircleFilled } from '@ant-design/icons';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import { usePropsValue } from '../../utils/use-props-value';
var classPrefix = 'pen-text-area';
var defaultProps = {
  defaultValue: '',
  rows: 2,
  showCount: false,
  autoSize: false
};
export var TextArea = /*#__PURE__*/forwardRef(function (p, ref) {
  var props = mergeProps(defaultProps, p);
  var maxLength = props.maxLength,
      autoSize = props.autoSize,
      showCount = props.showCount,
      clearable = props.clearable;

  var _usePropsValue = usePropsValue({
    value: props.value,
    defaultValue: props.defaultValue,
    onChange: props.onChange
  }),
      value = _usePropsValue[0],
      setValue = _usePropsValue[1];

  var _useState = useState(false),
      hasFocus = _useState[0],
      setHasFocus = _useState[1];

  var textAreaRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      clear: function clear() {
        setValue('');
      },
      focus: function focus() {
        var _a;

        (_a = textAreaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      },
      blur: function blur() {
        var _a;

        (_a = textAreaRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      }
    };
  });
  useLayoutEffect(function () {
    var textArea = textAreaRef.current;

    if (!textArea) {
      return;
    }

    textArea.style.height = 'auto';

    if (!autoSize) {
      return;
    }

    var height = textArea.scrollHeight;

    if (typeof autoSize === 'object') {
      var computedStyle = window.getComputedStyle(textArea);
      var lineHeight = parseFloat(computedStyle.lineHeight);

      if (autoSize.minRows) {
        height = Math.max(height, autoSize.minRows * lineHeight);
      }

      if (autoSize.maxRows) {
        height = Math.min(height, autoSize.maxRows * lineHeight);
      }
    }

    textArea.style.height = height + "px";
  }, [value, autoSize]);
  var count;

  if (typeof showCount === 'function') {
    count = showCount(value.length, maxLength);
  } else if (showCount) {
    count = /*#__PURE__*/React.createElement("div", {
      className: classPrefix + "-count"
    }, typeof maxLength === 'number' ? value.length + " / " + maxLength : value.length);
  }

  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classPrefix
  }, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-wrapper"
  }, /*#__PURE__*/React.createElement("textarea", {
    ref: textAreaRef,
    className: classPrefix + "-element",
    value: value,
    onChange: function onChange(evt) {
      setValue(evt.target.value);
    },
    placeholder: props.placeholder,
    rows: props.rows,
    autoComplete: props.autoComplete,
    autoCorrect: props.autoCorrect,
    spellCheck: props.spellCheck,
    disabled: props.disabled,
    readOnly: props.readOnly,
    name: props.name,
    onFocus: function onFocus(evt) {
      var _a;

      setHasFocus(true);
      (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, evt);
    },
    onBlur: function onBlur(evt) {
      var _a;

      setHasFocus(false);
      (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, evt);
    }
  }), Boolean(clearable && value && hasFocus) && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-clear",
    onMouseDown: function onMouseDown(evt) {
      evt.preventDefault();
    },
    onClick: function onClick() {
      var _a;

      setValue('');
      (_a = props.onClear) === null || _a === void 0 ? void 0 : _a.call(props);
    }
  }, /*#__PURE__*/React.createElement(CloseCircleFilled, null))), count));
});